async function executePolyfill(elements) {
  // Ignore browsers with picture element support.
  if (window.HTMLPictureElement) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('Picture element is supported.');
    }
    return;
  }

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('Picture element is not supported.');
  }

  // Import picturefill and run for the elements.
  const {
    default: picturefill,
  } = await import(/* webpackChunkName: "picturefill" */ 'picturefill');

  picturefill({
    elements,
    reevaluate: true,
  });
}

export default executePolyfill;
